import {SET_OWNER_SETTING, SET_SETTING, RESET_SETTINGS, AUTH_SUCCESS, AUTH_LOGOUT} from '@/store/mutation-types'
import Vue from "vue";
import debounce from "lodash/debounce"
import { $_getApiHost } from "../../components/mixins/global/env";
import ApiService from "../../service/ApiService";

const state = {
	settings: JSON.parse(localStorage.getItem('user-settings') || '{}'),
	ownerSettings: JSON.parse(localStorage.getItem('owner-settings') || '{"selected-operator-id":null,"selected-operator-name":null}'),
	ownerSettingsHash: localStorage.getItem('owner-settings-hash') || null
}

const getters = {
	hasSetting: (state) => (data) => {
		let module = data.module
		let settingKey = data.key
		return Boolean(state.settings.hasOwnProperty(module) && state.settings[module].hasOwnProperty(settingKey))
	},
	getSetting: (state) => (data) => {
		let module = data.module
		let settingKey = data.key
		if (state.settings.hasOwnProperty(module)) {
			return state.settings[module][settingKey]
		}
		return null
	},
	hasOwnerSetting: (state) => (key) => {
		return Boolean(state.ownerSettings.hasOwnProperty(key))
	},
	getOwnerSetting: (state) => (key) => {
		if (state.ownerSettings.hasOwnProperty(key)) {
			return state.ownerSettings[key]
		}
		return null
	},
	getSelectedOperatorId: state => {
		return state.ownerSettings.hasOwnProperty('selected-operator-id') ? state.ownerSettings['selected-operator-id'] : null;
	},
	getSelectedOperatorName: state =>  {
		return state.ownerSettings.hasOwnProperty('selected-operator-name') ? state.ownerSettings['selected-operator-name'] : null;
	},
	getOwnerSettingsHash: (state) => {
		return state.ownerSettingsHash
	}
}

const apiService = new ApiService($_getApiHost() +'/ui/', Vue)
const saveSettings = debounce((state) => {
  let userId = localStorage.getItem('user-id')
  let data = { user_settings: state.settings };
  if(userId) {
    apiService.callPut('me/users/' + userId + '/settings',  data)
  }
}, 3000)

const actions = {
	[SET_SETTING]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_SETTING, data)
			resolve()
		})
	},
	[RESET_SETTINGS]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(RESET_SETTINGS, data)
			resolve()
		})
	},
  [AUTH_LOGOUT]: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      commit(RESET_SETTINGS, data)
      resolve()
    })
  },
	[SET_OWNER_SETTING]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_OWNER_SETTING, data)
			resolve()
		})
	}
}

const mutations = {
	[SET_SETTING]: (state, data) => {
		let module = data.module
		let settingKey = data.key
		let settingValues = data.settings

		if (state.settings.hasOwnProperty(module)) {
			state.settings[module][settingKey] = settingValues
		} else {
			let newModuleSettings = {}
			newModuleSettings[module] = {[settingKey]: settingValues}
			Object.assign(state.settings, newModuleSettings)
		}
		localStorage.setItem('user-settings', JSON.stringify(state.settings))
    saveSettings(state)
	},
	[RESET_SETTINGS]: (state) => {
		state.settings = {};
		localStorage.setItem('user-settings', JSON.stringify({}))
	},
	[SET_OWNER_SETTING]: (state, data) => {
		let settingKey = data.key
		let settingValues = data.settings

		if (state.ownerSettings.hasOwnProperty(settingKey)) {
			state.ownerSettings[settingKey] = settingValues
		} else {
			let newOwnerSettings = {}
			newOwnerSettings[settingKey] = settingValues
			Object.assign(state.ownerSettings, newOwnerSettings)
		}
		state.ownerSettingsHash = JSON.stringify(state.ownerSettings)
		localStorage.setItem('owner-settings', JSON.stringify(state.ownerSettings))
		localStorage.setItem('owner-settings-hash', JSON.stringify(state.ownerSettings))
	},
  [AUTH_SUCCESS]: (state, data) => {
    state.settings = data['user'].user_settings || {}
    localStorage.setItem('user-settings', JSON.stringify(state.settings))
  }
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user-settings.js